import React from 'react'
import { Link } from 'react-router-dom'
import home1 from '../../images/home1.jpg'


const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="wpo-about-area-s2 section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={home1} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span>About</span>
                                <h2>YATRI INTERIORS</h2>
                            </div>
                            <h5>Transforming Spaces, Enhancing Lives – Yatri Interiors, Bengaluru</h5>
                            <p>Welcome to YATRI INTERIORS, your trusted partner for innovative and functional interior solutions in Bengaluru. Located in Yelahanka, we specialize in residential interiors, commercial interiors, office interiors,
                             and complete renovation solutions, tailored to your lifestyle or business needs.</p>
                             <p>With a passion for design and a commitment to quality, we offer end-to-end services including electrical & lighting solutions, painting, plumbing, and custom carpentry work. Whether you’re building your 
                             dream home or upgrading your office space, we ensure excellence in every corner.</p>
                            <div className="btns">
                                <Link onClick={ClickHandler} to="/about2" className="theme-btn">Read More</Link>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;


